import React from 'react';
import { LEK_COLOR_SCHEME } from '../types';

const Legend = ({ 
  title = 'LEK Probability Legend',
  showTitle = true 
}) => {
  const legendItems = Object.values(LEK_COLOR_SCHEME);

  return (
    <div style={{paddingTop: '0px', marginTop: '0px'}}>
      {showTitle && (
        <div className="section-title">
          {/* <span className="section-icon">🗺️</span> */}
          {/* {title} */}
        </div>
      )}
      
      <div className="legend" style={{paddingTop: '0px', marginTop: '0px'}}>
        {legendItems.map((item, index) => (
          <div key={index} className="legend-item" style={{justifyContent: 'center', textAlign: 'center', width: '100%'}}>
            <div 
              className="legend-color" 
              style={{ background: item.color, opacity: 0.7 }}
            ></div>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend; 